// Version du site pour invalider le cache
export const SITE_VERSION = '2.0.1';
export const BUILD_DATE = new Date().toISOString();

// Vérifier et mettre à jour la version au chargement
export function checkAndUpdateVersion() {
  const storedVersion = localStorage.getItem('site_version');
  
  if (storedVersion !== SITE_VERSION) {
    console.log(`Nouvelle version détectée: ${SITE_VERSION} (ancienne: ${storedVersion})`);
    console.log('Nettoyage du cache...');
    
    // Garder seulement le token pour ne pas déconnecter l'utilisateur
    const token = localStorage.getItem('token');
    const tokenTimestamp = localStorage.getItem('token_timestamp');
    const userRole = localStorage.getItem('user_role');
    const userId = localStorage.getItem('user_id');
    
    // Nettoyer tout
    localStorage.clear();
    sessionStorage.clear();
    
    // Restaurer les infos de connexion si présentes
    if (token) {
      localStorage.setItem('token', token);
      if (tokenTimestamp) localStorage.setItem('token_timestamp', tokenTimestamp);
      if (userRole) localStorage.setItem('user_role', userRole);
      if (userId) localStorage.setItem('user_id', userId);
    }
    
    // Sauvegarder la nouvelle version
    localStorage.setItem('site_version', SITE_VERSION);
    localStorage.setItem('last_cache_clear', new Date().toISOString());
    
    // Forcer le rechargement sans cache
    window.location.reload(true);
  }
}

// Vérifier si le cache est trop vieux (plus de 7 jours)
export function checkCacheFreshness() {
  const lastCacheClear = localStorage.getItem('last_cache_clear');
  
  if (lastCacheClear) {
    const daysSinceClear = (Date.now() - new Date(lastCacheClear).getTime()) / (1000 * 60 * 60 * 24);
    
    if (daysSinceClear > 7) {
      console.log('Cache trop ancien, nettoyage...');
      localStorage.setItem('last_cache_clear', new Date().toISOString());
      window.location.reload(true);
    }
  } else {
    localStorage.setItem('last_cache_clear', new Date().toISOString());
  }
}
